import axios from 'axios'
import router from '@/router' // 引入路由，登录过期跳转用
import Vue from 'vue'

// 1. 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 环境变量的基础地址
  timeout: 180000, // 60秒超时60000
  withCredentials: false // 跨域携带cookie（按需开启/关闭）
})

// 2. 请求拦截器：添加token、配置请求头
service.interceptors.request.use(
  (config) => {
    // 获取token（localStorage/Vuex按需修改）
    const token = JSON.parse(localStorage.getItem('token'))
    if (token) {
      config.headers['token'] = `${token}` // 后端约定字段可改
    }
    // 统一设置json请求头，form-data请求可单独覆盖
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    return config
  },
  (error) => {
    console.error('请求配置错误：', error)
    return Promise.reject(error)
  }
)

// 3. 响应拦截器：统一解析数据、处理错误（核心：原生提示替换Element Message）
service.interceptors.response.use(
  (response) => {
    Vue.prototype.$loading.close();
    // 解构后端返回数据（按你项目实际格式修改！核心：code/data/msg）
    const { code, data, msg } = response.data

    // 业务成功：后端约定的成功码（如200/0）
    if (code === 0) {
      return data // 直接返回核心数据，简化组件调用
    } else {
      if (response) {
        const status = response.data.code
        switch (status) {
          case 40001: // 未登录/登录过期
            // window.alert('登录已过期，请重新登录')
            localStorage.removeItem('token') // 清除过期token
            if (router.currentRoute.path !== '/') {
              router.replace('/login') // 跳转到登录页
            }
            break
          case 403: // 无权限
            // window.alert('您暂无权限进行此操作')
            break
          case 404: // 接口不存在
            // window.alert('请求的接口地址不存在')
            break
          case 500: // 服务器错误
            // window.alert('服务器内部错误，请稍后再试')
            break
          default:
            // window.alert(`请求失败，错误状态码：${status}`)
        }
      } else {
        // 无响应：网络断开/请求超时
        if (error.message.includes('timeout')) {
          // window.alert('请求超时，请检查网络连接')
        } else {
          // window.alert('网络异常，请检查你的网络连接')
        }
      }
      // return Promise.reject(new Error(msg || '请求失败'))
      return Promise.reject(response.data || '请求失败')
    }
  },
  (error) => {
    Vue.prototype.$loading.close();
    console.error('响应错误：', error)
    const { response } = error

    // 按HTTP状态码统一处理，全部用原生提示
    if (response) {
      const status = response.code
      switch (status) {
        case 40001: // 未登录/登录过期
          // window.alert('登录已过期，请重新登录')
          localStorage.removeItem('token') // 清除过期token
          router.replace('/login') // 跳转到登录页
          break
        case 403: // 无权限
          // window.alert('您暂无权限进行此操作')
          break
        case 404: // 接口不存在
          // window.alert('请求的接口地址不存在')
          break
        case 500: // 服务器错误
          // window.alert('服务器内部错误，请稍后再试')
          break
        default:
          // window.alert(`请求失败，错误状态码：${status}`)
      }
    } else {
      // 无响应：网络断开/请求超时
      if (error.message.includes('timeout')) {
        // window.alert('请求超时，请检查网络连接')
      } else {
        // window.alert('网络异常，请检查你的网络连接')
      }
    }
    return Promise.reject(error)
  }
)

// 导出封装后的axios实例
export default service